import { windowWidth, windowHeight } from '../common/Platform';


const aspect = windowWidth / windowHeight;
export default function px(size) {
    return windowWidth / 750 * size;
}